import { baseApi } from '@service/base.api';
import { injectAdminApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/admins.service';

export const adminApi = injectAdminApi(baseApi);

export const {
  useGetAdminQuery,
  useGetAdminsPaginatedQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useDeleteAdminMutation,
} = adminApi;
